<template v-bind="getCustomerConfiguration && getCategories && getAmenities && getParentUnits">
  <div>
    <div id="vue-search-widget"></div>

    <div class="book-location-div bookingband" id="book-location-div">
      <div class="book-inner-div">
        <!-- Location -->
        <div class="location-div book-common-div">
          <span>Location</span>
          <div class="img-location prefix">
            <img
                :src="`${hostProtocol}//${hostname}/wp-content/themes/queenwood/images/location.svg`"
                class="svg"
                alt="Location"
            />
            <select
                id="search_category"
                name="search_category"
                v-model="selectedCategory"
            >
              <option :value="null">Pick a Resort</option>
              <option v-for="item in getCategories" :key="item.id" :value="item.id">
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>

        <!-- Check in -->
        <div class="check-in-div book-common-div">
          <span>Check in</span>

          <div id="arrival_date_column" class="img-location">
            <img
                :src="`${hostProtocol}//${hostname}/wp-content/themes/queenwood/images/check-in.svg`"
                class="svg"
                alt="check-in"
            />
            <vue-pikaday
                v-model="selectedFromDate"
                placeholder="Pick a date"
                :options="pikadayOptions"
            />
          </div>
        </div>

        <!-- Length Of Stay -->
        <div class="check-out-div book-common-div">
          <span>Length Of Stay</span>
          <div class="img-location">
            <img
                :src="`${hostProtocol}//${hostname}/wp-content/themes/queenwood/images/check-in.svg`"
                class="svg"
                alt="check-in"
            />

            <!-- ✅ Single LOS dropdown driven by config + selected date -->
            <select
                name="search_period"
                v-model="days"
                id="search_period"
                :disabled="!selectedFromDate"
            >
              <option
                  v-for="opt in lengthOfStayOptions"
                  :key="String(opt.value)"
                  :value="opt.value"
                  :disabled="opt.disabled"
              >
                {{ opt.text | capitalize }}
              </option>
            </select>
          </div>
        </div>

        <!-- Guests -->
        <div class="guest-div book-common-div">
          <span>No. Guests</span>
          <div class="img-location">
            <img
                :src="`${hostProtocol}//${hostname}/wp-content/themes/queenwood/images/guest-img.svg`"
                class="svg"
                alt="guest-img"
            />

            <select
                v-if="selectedCategory == null"
                name="search_party_size"
                v-model="party"
                id="search_party_size"
            >
              <option v-for="guest in guests" :key="guest.value" :value="guest.value">
                {{ guest.text | capitalize }}
              </option>
            </select>

            <select
                v-else-if="selectedCategory == 48525"
                name="search_party_size"
                v-model="party"
                id="search_party_size"
            >
              <option v-for="guest in guestsRet" :key="guest.value" :value="guest.value">
                {{ guest.text | capitalize }}
              </option>
            </select>

            <select
                v-else-if="selectedCategory == 48526"
                name="search_party_size"
                v-model="party"
                id="search_party_size"
            >
              <option v-for="guest in guestsPort" :key="guest.value" :value="guest.value">
                {{ guest.text | capitalize }}
              </option>
            </select>

            <select
                v-else
                name="search_party_size"
                v-model="party"
                id="search_party_size"
            >
              <option v-for="guest in guests" :key="guest.value" :value="guest.value">
                {{ guest.text | capitalize }}
              </option>
            </select>
          </div>
        </div>

        <!-- Submit -->
        <div class="submit-btn">
          <button
              v-if="dayCheck && dateCheck && partyCheck"
              id="search_button"
              class="search_button"
              @click="getSearchResults"
          >
            Search
            <img
                :src="`${hostProtocol}//${hostname}/wp-content/themes/queenwood/images/white-arrow.png`"
                alt="white-arrow"
            />
          </button>
          <button
              v-else
              id="search_button"
              class="search_button disabled"
              @click="validation"
              title="Popover Title"
          >
            Search
            <img
                :src="`${hostProtocol}//${hostname}/wp-content/themes/queenwood/images/white-arrow.png`"
                alt="white-arrow"
            />
          </button>
        </div>
      </div>
    </div>

    <Transition name="fade">
      <div v-if="errorMessage" class="row mt-3 warning-inner-div">
        <div class="col-8 alert">
          Please set an arrival date, length of stay and number of guests before
          continuing
        </div>
      </div>
    </Transition>

    <br />

    <div>
      <div class="row" v-if="noResultsMessage">
        <div class="col">
          There are no results based on your search criteria, please try again
          with different dates
        </div>
      </div>

      <div>
        <div class="row">
          <div class="col">
            <p style="font-size: 15px" v-if="displayResults" class="col-12">
              We have found the following
              <strong>{{ searchResults.length }}</strong> results:
            </p>
          </div>
        </div>
      </div>

      <!-- Results -->
      <div id="scrollPoint" ref="scrollPoint">
        <div class="px-2" v-if="displayResults">
          <b-row
              v-bind:key="item.id"
              v-for="item in orderedSearchResults"
              class="row search-results"
              ref="search"
          >
            <div class="home-collection-feed">
              <div class="container">
                <div class="d-flex home-slider-content-div">
                  <div class="home-feed-slider slick-initialized slick-slider slick-dotted">
                    <carousel
                        :per-page="1"
                        :paginationEnabled="false"
                        :navigationClickTargetSize="-4"
                        :navigationEnabled="true"
                    >
                      <slide v-for="img in item.images" :key="img">
                        <div class="img-container">
                          <img
                              :src="img"
                              :alt="`${item.name}`"
                              style="width: 361px; height: 300px; object-fit: cover;"
                          />
                        </div>
                      </slide>
                    </carousel>
                  </div>

                  <div class="home-feed-content">
                    <div class="detail-price-div d-flex">
                      <div class="home-detail">
                        <div class="content">
                          <h3>
                            {{ item.unit_name }}
                            <span>
                              Retallack Resort | Sleeps up to {{ item.sleeps }}
                              <a
                                  :href="`${item.readmore_url}`"
                                  title="View Property"
                                  class="mobile view-property"
                              >
                                View Property &gt;
                              </a>
                            </span>
                          </h3>
                          <p v-html="item.unit_description">
                            {{ item.unit_description }}
                          </p>
                        </div>

                        <ul>
                          <li v-for="amenity in item.amenities" v-bind:key="amenity.id">
                            <span v-show="amenity === 1">
                              <img
                                  :src="`${hostProtocol}//${hostname}/wp-content/themes/queenwood/images/hot-tub.png`"
                                  alt="hottub"
                                  class="entered lazyloaded"
                                  width="92"
                                  height="69"
                              />
                              <span>Hot Tub</span>
                            </span>

                            <span v-show="amenity === 2">
                              <img
                                  :src="`${hostProtocol}//${hostname}/wp-content/themes/queenwood/images/dog-friendly.png`"
                                  alt="Dog friendly"
                                  class="entered lazyloaded"
                                  width="92"
                                  height="69"
                              />
                              <span>Dog friendly</span>
                            </span>

                            <span v-show="amenity === 15">
                              <img
                                  :src="`${hostProtocol}//${hostname}/wp-content/themes/queenwood/images/gym.png`"
                                  alt="Gym"
                                  class="entered lazyloaded"
                                  width="92"
                                  height="69"
                              />
                              <span>Gym</span>
                            </span>

                            <span v-show="amenity === 16">
                              <img
                                  :src="`${hostProtocol}//${hostname}/wp-content/themes/queenwood/images/bath-tub.png`"
                                  alt="Bathrooms"
                                  class="entered lazyloaded"
                                  width="92"
                                  height="69"
                              />
                              <span>{{ item.bathrooms }} # Bathrooms</span>
                            </span>

                            <span v-show="amenity === 17">
                              <img
                                  :src="`${hostProtocol}//${hostname}/wp-content/themes/queenwood/images/sleep.png`"
                                  alt="Sleeps"
                                  class="entered lazyloaded"
                                  width="92"
                                  height="69"
                              />
                              <span>Sleeps up to {{ item.sleeps }}</span>
                            </span>
                          </li>
                        </ul>
                      </div>

                      <div class="home-price">
                        <div class="date-guest-div">
                          <p>{{ selectedFromDate | moment("ddd D MMM YY") }}</p>
                          <p>{{ days }} nights</p>
                          <a
                              :href="`${item.readmore_url}`"
                              title="View Property"
                              class="view-more mobile"
                          >
                            View Property &gt;
                          </a>
                        </div>

                        <div class="content">
                          <h4>&pound;{{ item.price | formatPrice }}</h4>
                          <a
                              :href="item.online_deep_link"
                              title="Book Now"
                              class="book-now"
                          >
                            Book Now
                          </a>
                          <template v-if="item.readmore_url != ''">
                            <a
                                :href="item.readmore_url"
                                title="View Property"
                                class="view-more desktop"
                            >
                              View Property &gt;
                            </a>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </b-row>
        </div>
      </div>
    </div>

    <b-modal id="no_category" title="Select a location" ok-only>
      <h5>Please select where you would like to stay first</h5>
    </b-modal>

    <b-modal id="modal1" v-model="modalShow" title="Choose an arrival date">
      <p class="my-4">{{ modalMessage }}</p>
    </b-modal>

    <div id="vue-no-results" class="row resultsDisplay">
      <div class="col-4 offset-2 m-3">
        <h4>
          Unfortunately there is no availability for those dates please try
          again.
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Rewritten component: calendar rules are now data-driven.
 * The only behaviour change intended: the LOS dropdown is now a single select
 * computed from rules, instead of multiple v-if selects.
 */

const _ = require("lodash");
import Moment from "moment";
import { extendMoment } from "moment-range";
import { Carousel, Slide } from "vue-carousel";
import { between, required } from "vuelidate/lib/validators";
import SearchService from "@/services/SearchService";
import { authToken } from "@/config/client";

const moment = extendMoment(Moment);

// ===== ✅ Centralised rules (edit these, not methods/template) =====

const LOS_PRESETS = {
  all: [2, 3, 4, 5, 7, 10, 14],

  // Amy: Fri–Fri (7), Fri–Mon (3), Sat–Sat (7)
  fri: [3, 7],
  sat: [7],

  // Monday arrivals allowed in restricted windows; keep flexible midweek LOS
  mon: [3, 4, 5, 6, 7, 14],
  mid: [3, 4, 7],
};

const inRangeInclusive = (date, from, to) => date.isSameOrAfter(from, "day") && date.isSameOrBefore(to, "day");

// Fri / Sat / Mon arrival windows → matching LOS presets
const FSM_LOS = {
  1: "mon", // Monday
  5: "fri", // Friday
  6: "sat", // Saturday
};

const LOS_RULES = [
  // 27 Mar – 17 Apr: Fri / Sat / Mon only
  {
    name: "easter26",
    when: ({ date }) => inRangeInclusive(date, "2026-03-27", "2026-04-17"),
    losByDow: FSM_LOS,
    defaultLos: null,
  },
  {
    name: "easter27",
    when: ({ date }) => inRangeInclusive(date, "2027-03-27", "2027-04-17"),
    losByDow: FSM_LOS,
    defaultLos: null,
  },
  // 28 May – 10 Sep: Fri / Sat / Mon only
  {
    name: "summer26",
    when: ({ date }) => inRangeInclusive(date, "2026-05-28", "2026-09-10"),
    losByDow: FSM_LOS,
    defaultLos: null,
  },
  {
    name: "summer27",
    when: ({ date }) => inRangeInclusive(date, "2027-05-28", "2027-09-10"),
    losByDow: FSM_LOS,
    defaultLos: null,
  },
  // 22 Oct – 8 Nov: Fri / Sat / Mon only
  {
    name: "autumnHalfTerm26",
    when: ({ date }) => inRangeInclusive(date, "2026-10-22", "2026-11-08"),
    losByDow: FSM_LOS,
    defaultLos: null,
  },
  {
    name: "autumnHalfTerm27",
    when: ({ date }) => inRangeInclusive(date, "2027-10-22", "2027-11-08"),
    losByDow: FSM_LOS,
    defaultLos: null,
  },
  // Otherwise any-day arrivals (incl. after summer until 27 Dec, minus Christmas blocks)
  {
    name: "openAll",
    when: () => true,
    losByDow: "all",
  },
];

// disableDayFn uses [from, to) — `to` is exclusive.
// disableDow: 0=Sun … 6=Sat. Fri/Sat/Mon only → disable Sun/Tue/Wed/Thu = [0,2,3,4]
const NO_ARRIVALS = [0, 1, 2, 3, 4, 5, 6];
const FSM_ONLY = [0, 2, 3, 4];

// Shared across resorts — previously only 48526 was restricted, so 48525
// still allowed midweek dates (e.g. Thu 22 Oct) with full LOS.
const CALENDAR_DISABLE_RULES = [
  // 2026
  { between: ["2026-03-27", "2026-04-18"], disableDow: FSM_ONLY },
  { between: ["2026-05-28", "2026-09-11"], disableDow: FSM_ONLY },
  { between: ["2026-10-22", "2026-11-09"], disableDow: FSM_ONLY },
  { between: ["2026-12-23", "2026-12-27"], disableDow: NO_ARRIVALS }, // 23–26 Dec
  { between: ["2026-12-31", "2027-01-01"], disableDow: NO_ARRIVALS }, // 31 Dec

  // 2027 (same seasonal pattern; any day outside these windows)
  { between: ["2027-03-27", "2027-04-18"], disableDow: FSM_ONLY },
  { between: ["2027-05-28", "2027-09-11"], disableDow: FSM_ONLY },
  { between: ["2027-10-22", "2027-11-09"], disableDow: FSM_ONLY },
  { between: ["2027-12-23", "2027-12-27"], disableDow: NO_ARRIVALS },
  { between: ["2027-12-31", "2028-01-01"], disableDow: NO_ARRIVALS },
];

const DISABLE_RULES_BY_CATEGORY = {
  48526: CALENDAR_DISABLE_RULES,
  48525: CALENDAR_DISABLE_RULES,
};

export default {
  data() {
    return {
      // UI state
      errorMessage: false,
      dayCheck: false,
      dateCheck: false,
      partyCheck: false,

      // Search inputs
      selectedCategory: 48525,
      selectedUnit: 0,
      selectedFromDate: "",
      from_date: "",
      days: null,
      party: null,
      dow: null,

      // Guest options (kept from original)
      guests: [{ value: null, text: "Sleeps", disabled: false }],
      guestsRet: [
        { value: null, text: "Guests", disabled: false },
        { value: 4, text: "Up to 4 Guests", disabled: false },
        { value: 4, text: "Up to 5 Guests", disabled: false },
        { value: 8, text: "Up to 8 Guests", disabled: false },
        { value: 12, text: "Up to 12 Guests", disabled: false },
      ],
      guestsPort: [{ value: 14, text: "Sleeps up to 14", disabled: false }],

      // Environment
      hostname: window.location.hostname,
      hostProtocol: window.location.protocol,

      // Results
      availability: [],
      searchResults: [],
      displayResults: false,
      noResultsMessage: false,
      spinner: false,

      // Deep link caching
      online_deep_link: "",
      price: 0,

      // Misc existing fields (kept to avoid breaking other template/service usage)
      showCross: false,
      resultsHover: false,
      tag: "searchtoemail",
      visible: [],
      exposeRates: [],
      closeMatch: 0,
      showRates: [],
      config: [],
      selectedTemplate: 16701867,
      company_name: "",
      emailTo: "",
      emailSubject: "",
      emailName: "",
      emailCustomMessage: "",
      emailBodyTemplate: "",
      prepareEmailModal: false,
      emailTemplate: "",
      showPrepare: false,
      start_flag: false,
      online_flag: false,
      min_period: 1,
      toggleRules: true,
      onlineBadge: 0,
      displayColumns: true,
      amenitySelected: [],
      imageIterator: 1,
      checked: false,
      slide: 0,
      sliding: null,
      noResults: false,
      onlinePresetUrl: "",
      adultSelected: 2,
      childSelected: 0,
      categoryInput: "",
      arrivalInput: "",
      modalShow: false,
      modalMessage: "Please select an arrival date",
      emailSuccess: true,
      postmarkEmail: "",
      disablePrepareEmailButton: false,
      myAttribute: "",
      datePicked: "",
      parentUnits: [],
      units: [],
      categories: [],
      type: "number",
      categoryColumn: true,
      petSelected: false,
      bedrooms: 0,
    };
  },

  validations: {
    categoryInput: { required, minLength: between(1, 10000) },
    daysInput: { between: between(1, 30) },
  },

  components: { Carousel, Slide },

  filters: {
    capitalize(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.toLowerCase().slice(1);
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(",", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },

  created() {
    // Store
    this.$store.dispatch("getCategories", { auth_token: authToken });
    this.$store.dispatch("getUnits", { auth_token: authToken });
    this.$store.dispatch("getAvailability", { auth_token: authToken });
    this.$store.dispatch("getAmenities", { auth_token: authToken });
  },

  mounted() {
    // Restore cached search state
    setTimeout(() => {
      const cached = localStorage.getItem("atbSearchData");
      if (!cached) return;

      const parsed = JSON.parse(cached);
      if (!parsed.from_date) return;

      const m = moment(parsed.from_date);
      this.selectedFromDate = m.toDate();
      this.from_date = m.format("YYYY-MM-DD");
      this.dow = parsed.dow ?? m.day();

      this.days = parsed.days ?? null;
      this.party = parsed.party ?? null;

      this.dateCheck = !!this.from_date;
      this.dayCheck = !!this.days;
      this.partyCheck = !!this.party;

      if (parsed.deeplinkUrl) this.online_deep_link = parsed.deeplinkUrl;
      if (parsed.price) this.price = parsed.price;

      // ensure LOS rules computed and selected day still valid
      this.sanitizeSelectedLos();
    }, 0);
  },

  computed: {
    // Rebuilt whenever category changes so Pikaday re-draws disabled days
    pikadayOptions() {
      return {
        firstDay: 0,
        minDate: moment().startOf("day").toDate(),
        format: "DD/MM/YYYY",
        disableDayFn: (d) => this.dpInvalidDay(d),
        onSelect: (dt) => this.dateSelected(dt),
        // vue-pikaday deep-watches options — changing this forces a reload
        _category: this.selectedCategory,
        _availabilityVersion: this.$store.state.availability.length,
      };
    },

    orderedSearchResults() {
      return _.orderBy(this.searchResults, ["price", "sleeps", "unit_name"], ["asc", "asc", "asc"]);
    },

    // Store getters (kept as-is)
    getCustomerConfiguration() {
      return this.$store.getters.customerConfiguration;
    },
    loginType() {
      return this.$store.state.loginType;
    },
    getCategories() {
      return this.$store.getters.categories;
    },
    getParentUnits() {
      return this.$store.getters.categoryParentUnits(this.selectedCategory);
    },
    getAmenities() {
      return this.$store.getters.amenitySearch;
    },

    filterAmenities() {
      let amenityArray = [];
      let amenityTypeArray = [];
      let amenityIndex = 0;
      let amenitySearchResults = this.$store.getters.amenitySearch;
      if (amenitySearchResults !== false) {
        amenitySearchResults.forEach((element) => {
          amenityIndex = element.type;
          if (!amenityTypeArray[amenityIndex]) {
            amenityArray.push(element);
            amenityTypeArray[amenityIndex] = true;
          }
        });
      }
      return amenityArray;
    },

    orderedAmenities() {
      return _.orderBy(this.filterAmenities, "name");
    },

    // ✅ Single LOS options list (replaces options1/2/3/5/all + v-if template branching)
    lengthOfStayOptions() {
      if (!this.selectedFromDate) {
        return [{ value: null, text: "Length of Stay", disabled: false }];
      }

      const date = moment(this.selectedFromDate);
      const dow = date.day();

      const rule = LOS_RULES.find(r => r.when({ date, category: this.selectedCategory })) || null;

      let presetKey = "all";
      if (rule) {
        if (typeof rule.losByDow === "string") {
          presetKey = rule.losByDow;
        } else if (rule.losByDow && rule.losByDow[dow] != null) {
          presetKey = rule.losByDow[dow];
        } else if (rule.defaultLos) {
          presetKey = rule.defaultLos;
        } else if (rule.losByDow && typeof rule.losByDow === "object") {
          // Fri/Sat/Mon window but this weekday isn't an arrival day — no LOS
          return [{ value: null, text: "Length of Stay", disabled: false }];
        }
      }

      const values = LOS_PRESETS[presetKey] || LOS_PRESETS.all;

      return [
        { value: null, text: "Length of Stay", disabled: false },
        ...values.map(v => ({ value: v, text: `${v} days`, disabled: false })),
      ];
    },
  },

  watch: {
    from_date(newValue) {
      if (!newValue) return;
      this.dateCheck = true;
      this.persistSearchState();
    },
    days(newValue) {
      if (newValue == null) return;
      this.dayCheck = true;
      this.persistSearchState();
    },
    party(newValue) {
      if (newValue == null) return;
      this.partyCheck = true;
      this.persistSearchState();
    },
    toggleRules() {
      this.startFlag = !this.startFlag;
      this.disablePrepareEmailButton = !this.disablePrepareEmailButton;
    },
    selectedCategory(newValue, oldValue) {
      if (parseInt(newValue, 10) === 0 || parseInt(newValue, 10) !== parseInt(oldValue, 10)) {
        this.selectedUnit = 0;
      }
      // Drop arrival if it isn't valid for the newly selected resort
      if (this.selectedFromDate && this.dpInvalidDay(this.selectedFromDate)) {
        this.selectedFromDate = "";
        this.from_date = "";
        this.datePicked = "";
        this.dow = null;
        this.days = null;
        this.dateCheck = false;
        this.dayCheck = false;
      } else {
        this.sanitizeSelectedLos();
      }
    },

    // When arrival date changes, ensure the selected LOS is still valid
    selectedFromDate() {
      this.sanitizeSelectedLos();
    },
  },

  methods: {
    validation() {
      this.errorMessage = true;
      setTimeout(() => (this.errorMessage = false), 3000);
    },

    persistSearchState() {
      // Guard: only persist when we have a date object
      const fromDate = this.selectedFromDate ? moment(this.selectedFromDate).format("YYYY-MM-DD") : null;
      if (!fromDate) return;

      const atbSearchValues = {
        from_date: fromDate,
        days: this.days,
        party: this.party,
        dow: this.dow,
        price: this.price,
        deeplinkUrl: this.online_deep_link,
      };
      localStorage.setItem("atbSearchData", JSON.stringify(atbSearchValues));
    },

    sanitizeSelectedLos() {
      if (!this.selectedFromDate) return;

      const valid = this.lengthOfStayOptions.map(o => o.value).filter(v => v != null);
      if (this.days != null && !valid.includes(this.days)) {
        this.days = null;
        this.dayCheck = false;
      }
    },

    setDeeplink(item) {
      this.price = item.price;
      this.online_deep_link = item.online_deep_link;
      this.persistSearchState();
    },

    // ✅ Simplified: no more flag soup (openAll/highSeason/etc.)
    dateSelected(dt) {
      const dateObj = new Date(dt);
      this.selectedFromDate = dateObj;

      const m = moment(dateObj);
      this.datePicked = m;
      this.from_date = m.format("YYYY-MM-DD");
      this.dow = m.day();

      this.sanitizeSelectedLos();
    },

    // ✅ Centralised datepicker disable logic, driven by config
    dpInvalidDay(d) {
      const category = this.selectedCategory == null ? null : Number(this.selectedCategory);
      if (category == null || Number.isNaN(category)) return true;

      const date = moment(d).startOf("day");

      // Past dates disabled
      if (date.isBefore(moment().startOf("day"))) return true;

      const day = d instanceof Date ? d.getDay() : date.day();
      const rules = DISABLE_RULES_BY_CATEGORY[category] || [];

      const blockedBySeason = rules.some((r) => {
        const [from, to] = r.between;
        const inRange = date.isSameOrAfter(moment(from).startOf("day")) && date.isBefore(moment(to).startOf("day"));
        return inRange && r.disableDow.includes(day);
      });

      if (blockedBySeason) return true;

      // Availability overrides are maintained by the client and take
      // precedence over the recurring seasonal rules. A date is unavailable
      // when every returned unit is either prevented from starting or hidden.
      const availability = this.$store.getters.availability(
        date.format("YYYY-MM-DD"),
        date.format("YYYY-MM-DD"),
        category
      );

      return availability.length > 0 && availability.every((item) =>
        Number(item.start_flag) === 0 || Number(item.visibility) === 1
      );
    },

    categoryWarning() {
      if (this.selectedCategory == null) {
        this.$root.$emit("bv::show::modal", "no_category");
      }
    },

    highlightItem(item) {
      let selectedUnitId = item.unitId;
      this.searchResults.forEach((itemValue, itemIndex) => {
        if (itemValue.unitId === selectedUnitId && itemValue.deselected === true) {
          this.searchResults[itemIndex].deselected = false;
        } else if (itemValue.unitId === selectedUnitId && itemValue.deselected === false) {
          this.searchResults[itemIndex].deselected = true;
          this.showCross = true;
        }
      });
    },

    imgUrlAlt(event) {
      event.target.src =
          "https://thelaurelsholidaypark.co.uk/wp-content/uploads/2018/10/beach-scene.jpg";
    },

    getSearchResults() {
      // Search discovery and base rates come from UnifiedSearch through the
      // partner API. Keep the Queenwood result presentation here, but do not
      // recreate availability or pricing rules in the browser.
      this.displayResults = false;
      this.noResultsMessage = false;
      this.spinner = true;
      this.showPrepare = false;

      const request = {
        type: "unit",
        start_date: moment(this.from_date).format("YYYY-MM-DD"),
        end_date: moment(this.from_date).add(Number(this.days), "days").format("YYYY-MM-DD"),
        length_of_stay: Number(this.days),
        guests: Number(this.party),
        site_id: 0,
        category_ids: this.selectedCategory ? [Number(this.selectedCategory)] : [],
      };

      if (Number(this.selectedUnit) > 0) {
        request.unit_ids = [Number(this.selectedUnit)];
      }

      SearchService.search(authToken, request)
        .then((response) => {
          const units = this.$store.getters.unitsSearch(this.selectedCategory, 0);
          const amenities = this.getAmenities || [];
          const seen = {};

          this.searchResults = (Array.isArray(response.data) ? response.data : [])
            .filter((row) => {
              const id = Number(row.unit_id);
              if (!id || seen[id]) return false;
              seen[id] = true;
              return true;
            })
            .map((row) => {
              const unitId = Number(row.unit_id);
              const unit = units.find((item) => Number(item.id) === unitId) || {};
              const amenityArray = amenities
                .filter((amenity) => Number(amenity.unit_id) === unitId)
                .map((amenity) => Number(amenity.type))
                .filter((type, index, values) => values.indexOf(type) === index);
              const onlineBaseUrl = String(unit.deeplinkUrl || "").split("[")[0];
              const bookingUrl = onlineBaseUrl
                ? onlineBaseUrl +
                  moment(this.from_date).format("YYYY-MM-DD") +
                  "/" +
                  Number(this.days) +
                  "/0/" +
                  Number(this.party) +
                  "/0/0/0/0/"
                : row.url || "";

              return {
                unitId,
                unit_name: row.unit_name || unit.name,
                unit_description: row.description || unit.description || "",
                day: row.arrival_date || this.from_date,
                level: 1,
                deselected: false,
                availableOnline: this.onlineBadge,
                readmore_url: row.url || unit.readmore_url || "",
                thumbnail: "AB-white-logo.png",
                online_deep_link: bookingUrl,
                price: parseFloat(row.rate || 0, 10),
                sleeps: Number(row.occupancy || unit.occupancy || 0),
                city: row.city || (unit.location && unit.location.address.city) || "",
                county: row.state || (unit.location && unit.location.address.county) || "",
                images: {
                  1: row.thumbnail1 || "https://cdn.anytimebooking.io/unit/" + unitId + "-1.jpg",
                  2: row.thumbnail2 || "https://cdn.anytimebooking.io/unit/" + unitId + "-2.jpg",
                  3: row.thumbnail3 || "https://cdn.anytimebooking.io/unit/" + unitId + "-3.jpg",
                  4: row.thumbnail4 || "https://cdn.anytimebooking.io/unit/" + unitId + "-4.jpg",
                },
                amenities: amenityArray,
              };
            });

          this.noResultsMessage = this.searchResults.length === 0;
          this.displayResults = this.searchResults.length > 0;
          if (this.displayResults) {
            this.$nextTick(() => this.$refs["scrollPoint"].scrollIntoView({ behavior: "smooth" }));
          }
        })
        .catch(() => {
          this.searchResults = [];
          this.noResultsMessage = true;
          this.displayResults = false;
        })
        .finally(() => {
          this.spinner = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/* unchanged styles (kept from your original component) */
.text-overflow-handle {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.warning-inner-div {
  width: 100%;
  max-width: 1034px;
  margin: 0 auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.alert {
  background-color: #f8d7da;
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.bookingband {
  .submit-btn {
    .disabled {
      background-color: #c9a5b3;
    }
  }
}

.img-location img {
  margin-right: 6px;
  max-width: 23px;
  max-height: 23px;
}

.prepareEmail {
  font-weight: 600;
  cursor: pointer;
}

.online-dot {
  height: 15px;
  width: 15px;
  background-color: lightgreen;
  border-radius: 50%;
  display: inline-block;
}

.offline-dot {
  height: 15px;
  width: 15px;
  background-color: red;
  border-radius: 50%;
  display: inline-block;
}

.material-icons {
  color: red;
}

.card-img,
.card-img-top {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.resultsrow .row {
  margin-right: 0 !important;
  margin-left: 0;
}

#htmlTemplate {
  img {
    width: 100%;
    height: auto;
  }
}

.resultsDisplay {
  display: none;
}

.resultsBody {
  padding: 10px;
}

svg:not(:root).svg-inline--fa {
  overflow: visible;
}

.svg-inline--fa.fa-w-16 {
  width: 1em;
}

.svg-inline--fa {
  margin-right: 3px;
  padding-top: 3px;
  margin-top: 5px;
  color: grey;
}

.showNoResults {
  display: inline;
}

.material-icons {
  color: grey !important;
}

input,
select {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  width: 100%;
}

.vdp-datepicker {
  input {
    padding: 5px;
    font-size: 0.75rem;
  }
}

.custom-select {
  font-size: 0.75rem;
}

.btn {
  font-size: 0.75rem;
}

.link {
  border-radius: 4px;
  text-decoration: none;
  padding: 0.95rem 1rem;
  width: -moz-fit-content;
  display: block;
  color: rgb(190, 78, 28);
  background-color: transparent;
  border: 2px solid rgb(190, 78, 28);
  transition: all 0.3s ease 0s;
  cursor: pointer;
}

.link:hover {
  background-color: rgb(190, 78, 28);
  color: white;
}

.btn-anytime-inverse {
  background-color: #fff;
  color: #87ba78;
  border: 1px solid #87ba78;
  float: right;
}

.btn-disabled {
  background-color: rgb(211, 205, 205);
  color: #fff;
  border: 1px solid #87ba78;
  float: right;
}

.unitdescription {
  height: 150px;
  overflow: hidden;
}

.unitlocation {
  height: 20px;
}

.unitimage {
  max-height: 300px;
  overflow: hidden;
}

.results {
  position: relative;
}

.results__overlay__default {
  position: absolute;
  top: 10px;
  left: 15px;
  width: 20px;
  height: 20px;
  z-index: 999;
}

.hideCross {
  display: none;
}

.VueCarousel-slide {
  position: relative;
  min-height: 100px;
}
</style>

<!-- Unscoped: Pikaday renders on document.body. Kill theme button chrome that shows as squares under the arrows. -->
<style lang="scss">
.pika-single {
  .pika-prev,
  .pika-next {
    appearance: none !important;
    -webkit-appearance: none !important;
    background: none !important;
    background-image: none !important;
    background-color: transparent !important;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    outline: none !important;
    color: transparent !important;
    font-size: 0 !important;
    line-height: 0 !important;
    text-indent: 0 !important;
    text-shadow: none !important;
    overflow: visible !important;
    position: absolute !important;
    top: 4px !important;
    width: 28px !important;
    height: 28px !important;
    padding: 0 !important;
    margin: 0 !important;
    opacity: 1 !important;
    cursor: pointer !important;

    &::before,
    &::after {
      border: 0 !important;
      background: none !important;
      box-shadow: none !important;
      width: auto !important;
      height: auto !important;
    }

    &::before {
      content: "" !important;
      position: absolute !important;
      top: 50% !important;
      left: 50% !important;
      margin: 0 !important;
      padding: 0 !important;
      font-size: 22px !important;
      line-height: 1 !important;
      font-weight: 400 !important;
      color: #595959 !important;
      transform: translate(-50%, -54%) !important;
      pointer-events: none !important;
    }
  }

  .pika-prev {
    left: 0 !important;
    right: auto !important;
    float: none !important;

    &::before {
      content: "‹" !important;
    }
  }

  .pika-next {
    right: 0 !important;
    left: auto !important;
    float: none !important;

    &::before {
      content: "›" !important;
    }
  }

  .pika-title {
    position: relative !important;
  }

  .pika-label {
    display: inline-block !important;
    padding-right: 14px !important;
    background: none !important;
    background-image: none !important;
    overflow: visible !important;
    position: relative !important;

    &::before,
    &::after {
      background: none !important;
      box-shadow: none !important;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
    }

    &::after {
      content: "▾" !important;
      position: absolute !important;
      top: 50% !important;
      right: 0 !important;
      width: auto !important;
      height: auto !important;
      margin: 0 !important;
      padding: 0 !important;
      border: 0 !important;
      font-size: 11px !important;
      line-height: 1 !important;
      color: #595959 !important;
      transform: translateY(-50%) !important;
      z-index: 2 !important;
      pointer-events: none !important;
    }
  }

  .pika-title select {
    appearance: none !important;
    -webkit-appearance: none !important;
    background: none !important;
    border: 0 !important;
  }

  .pika-title .pika-select {
    opacity: 0 !important;
  }
}
</style>
